module.exports = __webpack_public_path__ + "img/奔宝博世.png";